import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Select, Row, Col, Typography} from "antd";
import axios from "../../config/axiosInstance";
import { useTheme } from "../../context/ThemeContext";
import { Chart as ChartJS, ArcElement, BarElement, CategoryScale, LinearScale, Tooltip as ChartTooltip, Legend } from "chart.js";
import UpcomingEventsCalendar from "../Pages/UpcomingEventsCalendar";
import DeviceUsageDetails from "./ClientReport/DeviceUsageDetails";
import DeviceUsageMonths from "./ClientReport/DeviceUsageMonths";
import DeviceUsageMonthsFlat from "./ClientReport/DeviceUsageMonthsFlat";
import { DoughnutChartCard, StackedBarChartCard, getDoughnutChartData, getDoughnutOptions, getStackedBarChartData, getStackedBarOptions } from './ClientReport/ClientReportChartsModule';

ChartJS.register(ArcElement, BarElement, CategoryScale, LinearScale, ChartTooltip, Legend);

const { Title } = Typography;
const { Option } = Select;

const ClientReport = () => {
    const { darkTheme } = useTheme();
    const textColor = darkTheme ? "#FFFFFF" : "#000000";
    const location = useLocation();
    const client = location.state?.client;

    const [year, setYear] = useState(new Date().getFullYear());
    const [deviceUsageData, setDeviceUsageData] = useState([]);

    const fetchDeviceUsage = async (clientId, selectedYear) => {
        try {
            const response = await axios.get(`/clients-report/${clientId}/device-usage/${selectedYear}`);
            setDeviceUsageData(response.data);
        } catch (error) {
            console.error("Error fetching device usage data:", error);
        }
    };

    useEffect(() => {
        if (client && client._id) {
            fetchDeviceUsage(client._id, year);
        }
    }, [year, client]);

    const doughnutChartData = getDoughnutChartData(deviceUsageData);
    const doughnutOptions = getDoughnutOptions(textColor);
    const stackedBarChartData = getStackedBarChartData(deviceUsageData);
    const barOptions = getStackedBarOptions(textColor);

    return (
        <div style={{ padding: "20px" }}>
            <Title style={{ color: textColor, display: "flex", alignItems: "center", gap: "20px" }}>
                {client?.portalLogo && (
                    <img src={client.portalLogo} alt="Portal Logo" style={{ width: 60, height: 60, objectFit: "contain" }} />
                )}
                {client?.name}
            </Title>

            <Select value={year} onChange={setYear} style={{ width: 150, marginBottom: 20 }}>
                <Option value={2024}>2024</Option>
                <Option value={2025}>2025</Option>
            </Select>

            <Row gutter={[16, 16]} align="stretch">
                <Col xs={24} sm={12} md={10} style={{ display: "flex" }}>
                    <DoughnutChartCard
                        deviceUsageData={deviceUsageData}
                        doughnutChartData={doughnutChartData}
                        doughnutOptions={doughnutOptions}
                        textColor={textColor}
                    />
                </Col>
                <Col xs={24} sm={12} md={14} style={{ display: "flex" }}>
                    <div style={{ width: "100%", height: "100%", display: "flex" }}>
                        <UpcomingEventsCalendar showSidebar={false} />
                    </div>
                </Col>
            </Row>

            <DeviceUsageMonthsFlat
                client={client}
                year={year}
                darkTheme={darkTheme}
                style={{ marginTop: 20 }}
            />

            <DeviceUsageMonths
                client={client}
                year={year}
                darkTheme={darkTheme}
                style={{ marginTop: 20 }}
            />

            <DeviceUsageDetails
                deviceUsageData={deviceUsageData}
                client={client}
                darkTheme={darkTheme}
                style={{ marginTop: 20 }}
            />

            <Row gutter={[16, 16]} style={{ marginTop: 20 }}>
                <Col span={24}>
                    <StackedBarChartCard
                        deviceUsageData={deviceUsageData}
                        stackedBarChartData={stackedBarChartData}
                        barOptions={barOptions}
                    />
                </Col>
            </Row>


        </div>
    );
};

export default ClientReport;